import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09885cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fgc-obs" }
const _hoisted_2 = { class: "prize-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, "$" + _toDisplayString(_ctx.currentTotal.toFixed(2)), 1)
  ]))
}